import { createFileRoute } from "@tanstack/react-router";

import TermsTrialRoute from "@/components/Legals/TermsTrialRoute";

export const Route = createFileRoute("/terms-trial")({
  component: TermsTrialRoute,
});
